jQuery(document).ready(function ($) {

    $('.laime').on('click', function (e) {
        if (e.target === this){
            $('.laime').addClass('hidden');
        }
    });

    $('.laime .close').on('click', function (e) {
        e.preventDefault();
        $('.laime').addClass('hidden');
    });

    var animatedSlides = [
        {
            isAnimated: false,
            hashes: ['homepage', 'pagrindinis'],
            selector: '.s-homepage'
        },
        {
            isAnimated: false,
            hashes: ['history', 'pagrindinis'],
            selector: '.s-history'
        },
        {
            isAnimated: false,
            hashes: ['products', 'pagrindinis'],
            selector: '.s-products'
        },
        {
            isAnimated: false,
            hashes: ['36000years', 'pagrindinis'],
            selector: '.s-years'
        }
    ];

    var setAnimatedTrue = function (hash) {
        animatedSlides.forEach(function (item) {
            if(item.hashes.indexOf(hash.substr(1)) != -1) {
                item.isAnimated = true;
                setTimeout(function(){ $(item.selector).addClass('animating'); }, 400);
            }
        });
    };

    var processHashChanges = function () {
        var hash = window.location.hash;

        if(!hash.length)
            setAnimatedTrue('#homepage');
        else
            setAnimatedTrue(window.location.hash);
    };

    processHashChanges();

    setTimeout(function(){ $('body').addClass('other-anim'); }, 400);

    $(window).on('hashchange', function () {
        if ($(window).width() > 767) {
            processHashChanges();
        }
    });

    $('#h-video').on('ended',function(){
        var video = $(this);
        $('.section.s-homepage').addClass('last-frame');
        $('.first-frame-img').hide();
        $('.last-frame-img').show();
        setTimeout(function(){ video.fadeOut() }, 10);
    });

    if ($(window).width() > 767) {
        $('#fullpage').fullpage({
            animateAnchor: false,
            fitToSection: false,
            menu: '#navMenu',
            scrollOverflow: false,
            afterLoad: function(anchorLink, index){
                if(index == 1) {
                    setTimeout(function(){
                        if ($('.s-homepage').hasClass('animating') && !$('#h-video').hasClass('viewed')) {
                            $('#h-video').css('display', 'block');
                            $('#h-video').get(0).play();
                            $('#h-video').addClass('viewed');
                        }
                    }, 401);
                }
                if(index == 3) {
                    $('.products-nav').addClass('active');
                }
            },
            onLeave: function(index, nextIndex, direction){
                if(index == 3){
                    $('.products-nav').removeClass('active');
                }

                var mAc = nextIndex - 1;

                $('.link--page').removeClass('active');
                $('.pages-nav__item:nth-of-type(' + mAc + ') .link--page').addClass('active');
            },
            afterRender: function() {

            }
        });
    } else {
        $('.s-homepage').waypoint(function(direction) {
            this.element.classList.add('animating');
        }, {
            context: '#fullpage',
            offset: '75%'
        });

        $('.s-history').waypoint(function(direction) {
            this.element.classList.add('animating');
        }, {
            context: '#fullpage',
            offset: '75%'
        });

        $('.s-products').waypoint(function(direction) {
            this.element.classList.add('animating');
        }, {
            context: '#fullpage',
            offset: '75%'
        });

        $('.s-years').waypoint(function(direction) {
            this.element.classList.add('animating');
        }, {
            context: '#fullpage',
            offset: '75%'
        });
    }

    var he1 = $('.s-homepage').outerHeight();
    var he2 = $('.s-history').outerHeight();
    var he3 = $('.s-products').outerHeight();
    var he4 = $('.s-years').outerHeight();

    if ($(window).width() > 767) {
        $('.link-first').on('click', function() {
            setTimeout(function(){ $.fn.fullpage.moveTo(1) }, 450);

            if (($('#product-slider').hasClass('info-opened'))) {
                $('.back-to-slider').click();
            }
        });
        $('.link-second').on('click', function() {
            setTimeout(function(){ $.fn.fullpage.moveTo(2) }, 450)
        });
        $('.link-third').on('click', function() {
            setTimeout(function(){ $.fn.fullpage.moveTo(3) }, 450);
            if (($('#product-slider').hasClass('info-opened'))) {
                $.fn.fullpage.setAllowScrolling(false);
                $.fn.fullpage.setKeyboardScrolling(false);
            } else {
                $.fn.fullpage.setAllowScrolling(true);
                $.fn.fullpage.setKeyboardScrolling(true);
            }
        });
        $('.link-fourth').on('click', function() {
            setTimeout(function(){ $.fn.fullpage.moveTo(4) }, 450)
        });

        $('.link--page').on('click', function() {
            $('.link--page').removeClass('active');
            $(this).addClass('active');
        });
    } else {
        $('.link-first').on('click', function() {
            setTimeout(function(){
                $('#fullpage').animate({
                    scrollTop: 0
                }, 1000);
            }, 450);

            if (($('#product-slider').hasClass('info-opened'))) {
                $('.back-to-slider').click();
            }
        });
        $('.link-second').on('click', function() {
            setTimeout(function(){
                $('#fullpage').animate({
                    scrollTop: he1
                }, 1000);
            }, 450);
        });
        $('.link-third').on('click', function() {
            setTimeout(function(){
                $('#fullpage').animate({
                    scrollTop: he1 + he2
                }, 1000);
            }, 450);
        });
        $('.link-fourth').on('click', function() {
            setTimeout(function(){
                $('#fullpage').animate({
                    scrollTop: he1 + he2 + he3
                }, 1000);
            }, 450);
        });
    }

    $('.big-bottom-text').fitText(0.55);
    $('.s-years .big-bottom-text').fitText(0.65);
    if ($('html').attr('lang') === 'ru-RU') {
        $('.s-products .big-bottom-text').fitText(0.65);
        $('.section-products .big-bottom-text').fitText(0.65);
    }

    function resizeFunc() {
        if ($(window).width() > 767) {
            if (!$('html').hasClass('fp-enabled')) {
                $('#fullpage').fullpage({
                    animateAnchor: false,
                    menu: '#navMenu',
                    scrollOverflow: true,
                    afterLoad: function(anchorLink, index){
                        if(index == 3){
                            $('.products-nav').addClass('active');
                        }
                    },
                    onLeave: function(index, nextIndex, direction){
                        if(index == 3){
                            $('.products-nav').removeClass('active');
                        }
                    }
                });
            } else {
                $.fn.fullpage.reBuild();
            }
        } else {
            if ($('html').hasClass('fp-enabled')) {
                $.fn.fullpage.destroy('all');
            }
        }
    }

    $(window).on("resize", resizeFunc);

    $('.docu-frame').on('click', function() {
        $('.docu-overlay').addClass('active');
        $('.docu-overlay').css('left', '0');
        if ($('html').hasClass('fp-enabled')) {
            $.fn.fullpage.setAllowScrolling(false);
            $.fn.fullpage.setKeyboardScrolling(false);
        }
    });

    $('.first-read-more-trig').on('click', function() {
        $('.first-read-more').addClass('active');
        $('.first-read-more').css('left', '0');
        if ($('html').hasClass('fp-enabled')) {
            $.fn.fullpage.setAllowScrolling(false);
            $.fn.fullpage.setKeyboardScrolling(false);
        }
    });

    $('.second-read-more-trig').on('click', function() {
        $('.second-read-more').addClass('active');
        $('.second-read-more').css('left', '0');
        if ($('html').hasClass('fp-enabled')) {
            $.fn.fullpage.setAllowScrolling(false);
            $.fn.fullpage.setKeyboardScrolling(false);
        }
    });

    $('.docu-overlay').on('click', function() {
        $(this).removeClass('active');
        setTimeout(function() {
            $('.docu-overlay').css('left', '-100%')
        }, 400);
        $.fn.fullpage.setAllowScrolling(true);
        $.fn.fullpage.setKeyboardScrolling(true);
    });

    jQuery('.first-read-more li, .second-read-more li').wrapInner('<span/>');

    $('.first-read-more, .second-read-more').on('click', function(e) {
        var thiss = $(this);
        console.log(e)
        if (e.target.localName == 'p' || e.target.className == 'mCSB_dragger_bar') {
            return;
        } else if (e.target.localName == 'h3' || e.target.localName == 'ul' || e.target.localName == 'li' || e.target.localName == 'span') {
            return;
        } else {
            thiss.removeClass('active');
            setTimeout(function() {
                $('.first-read-more').css('left', '-100%');
                $('.second-read-more').css('left', '-100%');
            }, 400);
            $.fn.fullpage.setAllowScrolling(true);
            $.fn.fullpage.setKeyboardScrolling(true);
        }
    });

    var iframe = $('#video')[0];
    var player = $f(iframe);

    // Open on play
    $('.video-trig').click(function(){
        $('.overlay').css('left', 0);
        $('.overlay').addClass('show');
        $('.h-nav').addClass('close-video');
        player.api("play");
        if ($('html').hasClass('fp-enabled')) {
            $.fn.fullpage.setAllowScrolling(false);
            $.fn.fullpage.setKeyboardScrolling(false);
        }
    });

    // Closes on click outside
    $('.overlay').click(function(){
        $('.overlay').removeClass('show');
        $('.h-nav').removeClass('close-video');
        setTimeout(function() {
            $('.overlay').css('left', '-100%')
        }, 300);
        player.api("pause");
        if ($('html').hasClass('fp-enabled')) {
            $.fn.fullpage.setAllowScrolling(true);
            $.fn.fullpage.setKeyboardScrolling(true);
        }
    });

    $(".read-more-text-wrap").mCustomScrollbar({
        scrollInertia: 0
    });

    $('.overlay-trigger').on('click', function(){
        $('.overlay').removeClass('show');
        $('.h-nav').removeClass('close-video');
        setTimeout(function() {
            $('.overlay').css('left', '-100%')
        }, 300);
        player.api("pause");
        if ($('html').hasClass('fp-enabled')) {
            $.fn.fullpage.setAllowScrolling(true);
            $.fn.fullpage.setKeyboardScrolling(true);
        }
    });

    $('.mobile-product-back').on('click', function(){
        $('.h-nav').removeClass('product-back');
        $('.mobile-product-info').removeClass('active');

        if (($('#product-slider').hasClass('info-opened'))) {
            $('.owl-stage-outer').css('overflow', 'hidden');
            $('#product-slider').toggleClass('bottles-hidden');
        }

        $('#product-slider').toggleClass('info-opened');
        $('.back-to-slider').toggleClass('active');
        $('.main-header').toggleClass('menu-opened');
        $('.bottle-slide').removeClass('get-more');
        $('#navMenu').toggleClass('info-opened');
        $('.slide-numbers').toggleClass('hidden');
        $('.s-products .products-nav').removeClass('hidden');
    });

    $('.mobile-product-info-close').on('click', function(){
        $('.h-nav').removeClass('product-close');
        $('.mobile-product-info-more').removeClass('active');
        $('.mobile-product-info').addClass('active');
        $('.h-nav').addClass('product-back');
    });

    function dragCallbackAdd() {
        $('.owl-carousel').addClass('dragging');
    }
    function dragCallbackRemove() {
        $('.owl-carousel').removeClass('dragging');

        if ((!$('#page-vitafruit').length > 0) && (!$('#page-active').length > 0)) {
            var currAttr = $('.owl-carousel .center .bottle-slide').attr('data-group');

            $('.products-nav li').removeClass('active');
            $('.products-nav li:nth-of-type(' + currAttr + ')').addClass('active');
        }
    }

    var carousel = $("#product-slider");

    carousel.owlCarousel({
        items: 1,
        loop: true,
        center: true,
        nav: true,
        itemsSelector: 'bottle-slide',
        onDrag: dragCallbackAdd,
        onDragged: dragCallbackRemove,
        onTranslate: dragCallbackAdd,
        onTranslated: dragCallbackRemove,
        smartSpeed: 300,
        touchDrag: false,
        URLhashListener: false,
        startPosition: '1',
        responsive : {
            1000 : {
                startPosition: '1',
                touchDrag: true,
                items: 3
            }
        }
    });

    $('.owl-item.center').prev().addClass('left');
    $('.owl-item.center').next().addClass('right');

    carousel.on('translate.owl.carousel', function(e){
        var idx = e.item.index;
        $('.owl-item.left').removeClass('left');
        $('.owl-item.right').removeClass('right');
        $('.owl-item').eq(idx-1).addClass('left');
        $('.owl-item').eq(idx+1).addClass('right');
    });

    // carousel.on('changed.owl.carousel', function(e) {
    //     $('.slide-numbers').text(e.page.index+1 + ' / ' + e.page.count);
    // });

    // $('.slide-numbers').text('1 / ' + $('.owl-item:not(.cloned)').length);

    $('.products-nav li').on('click', function() {
        var clkIdx = $(this).index() + 1;
        if (clkIdx == 1) {
            carousel.trigger('to.owl.carousel', 1)
        } else if (clkIdx == 2) {
            var sTo = parseInt($('.p-nav-item:first-of-type').attr('data-count'));
            carousel.trigger('to.owl.carousel', sTo+1)
        } else if (clkIdx == 3) {
            var sTo1 = parseInt($('.p-nav-item:first-of-type').attr('data-count'));
            var sTo2 = parseInt($('.p-nav-item:nth-of-type(2)').attr('data-count'));
            var sTo = sTo1 + sTo2;
            carousel.trigger('to.owl.carousel', sTo+1)
        }
    });

    $(".disable-owl-swipe").on("touchstart mousedown", function(e) {
        // Prevent carousel swipe
        e.stopPropagation();
    });

    $('.bottle, .back-to-slider').on('click', function() {
        var dataWord = $(this).attr('data-word');
        var dataDefaultWord = $('.s-products .big-bottom-text').attr('data-default-word');

        var clickedElem = $(this);



        if ($(window).width() > 768) {
            $(".bottle-info-more-content").mCustomScrollbar({
                scrollInertia: 0,
                updateOnWindowResize: true
            });
        }

        if (($('#product-slider').hasClass('info-opened'))) {
            if ($('html').hasClass('fp-enabled')) {
                $.fn.fullpage.setAllowScrolling(true);
                $.fn.fullpage.setKeyboardScrolling(true);
            }
            setTimeout(function(){
                $('.owl-stage-outer').css('overflow', 'hidden');
                $('#product-slider').toggleClass('bottles-hidden');
            }, 450);
            $('.s-products .big-bottom-text').html(dataDefaultWord);

            if (($('#page-vitafruit').length > 0) && ($(window).width() > 1000)) {
                $('#page-vitafruit').removeClass('fixed');
            }
            if (($('#page-active').length > 0) && ($(window).width() > 1000)) {
                $('#page-active').removeClass('fixed');
            }
        } else {

            if (($('#page-vitafruit').length > 0) && ($(window).width() > 1000)) {
                $('#page-vitafruit').animate({
                    scrollTop: $(".section-hero").outerHeight()
                }, 300).addClass('fixed');
            }
            if (($('#page-active').length > 0) && ($(window).width() > 1000)) {
                $('#page-active').animate({
                    scrollTop: $(".section-hero-active").outerHeight()
                }, 300).addClass('fixed');
            }

            if ($('html').hasClass('fp-enabled')) {
                $.fn.fullpage.setAllowScrolling(false);
                $.fn.fullpage.setKeyboardScrolling(false);
            }
            $('.owl-stage-outer').css('overflow', 'visible');
            $('#product-slider').toggleClass('bottles-hidden');
            $('.s-products .big-bottom-text').html(dataWord);

            var text = clickedElem.closest('.bottle-slide').find('.bottle-info').clone();
            var textMore = clickedElem.closest('.bottle-slide').find('.bottle-info-more').clone();
            $('.mobile-product-info').html("").html(text);
            $('.mobile-product-info-more').html("").html(textMore);
            $('.mobile-product-info, .mobile-product-info-more').animate({
                scrollTop: 0
            }, 0);
            clickedElem.closest('.bottle-slide').find('.bottle').clone().appendTo('.mobile-product-info .bottle-info-content');
        }

        if ($(window).width() < 768) {
            $('.h-nav').addClass('product-back');
            $('#fullpage').animate({
                scrollTop: he1 + he2
            }, 500);
        }

        $('#product-slider').toggleClass('info-opened');
        $('.back-to-slider').toggleClass('active');
        $('.main-header').toggleClass('menu-opened');
        $('.bottle-slide').removeClass('get-more');
        $('#navMenu').toggleClass('info-opened');
        $('.slide-numbers').toggleClass('hidden');
        $('.s-products .products-nav').addClass('hidden');


        $('.mobile-product-info').addClass('active');
    });

    //$('.info-bubble').on('click', function() {
    //    $('.h-nav').addClass('product-back');
    //});

    $('.bottle-slide .more-info').on('click', function() {
        $(this).closest('.bottle-slide').addClass('get-more');
    });

    $('.mobile-product-info').on('click', '.more-info', function() {
        $('.mobile-product-info').removeClass('active');
        $('.mobile-product-info-more').addClass('active');
        $('.h-nav').removeClass('product-back');
        $('.h-nav').addClass('product-close');
    });

    $('.close-info-more').on('click', function() {
        $('.bottle-slide').removeClass('get-more');
    });

    jQuery('img.svg').each(function(){
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if(typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if(typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass+' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });

    $(window).on('hashchange', function () {
        if ($(window).width() > 1000) {
            carousel.trigger('to.owl.carousel', 1)
        }
    });

    var cookieBlock = $('.cookies-policy');

    if(cookieBlock.length > 0) {
        cookieBlock.addClass('show');
    }

    cookieBlock.find('.close-block').on('click', function () {

        var d = new Date();
        d.setTime(d.getTime() + (30*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = "cookieBlock=" + d + ";" + expires + ";path=/";

        cookieBlock.removeClass('show');
    })
});

jQuery(window).resize(function ($) {

});

jQuery(window).on('load', function() {
    if (jQuery('html').attr('lang') != "lv") {
        jQuery('.kitaLaime .inner').addClass('ru');
    } else {
        jQuery('.kitaLaime .inner').addClass('lv');
    }

    setTimeout(function(){
        jQuery('.kitaLaime').fadeIn(500);
    }, 500);

    jQuery('.kitaLaime .close').on('click', function(){
        jQuery('.kitaLaime').fadeOut(500, function(){
            jQuery('.kitaLaime').remove();
        });
    });

    jQuery('.kitaLaime').on('click', function(e){
        if (!(jQuery(e.target).is('.kitaLaime-content') || jQuery(e.target).closest('.kitaLaime-content').length > 0)) {
            jQuery('.kitaLaime').fadeOut(500, function(){
                jQuery('.kitaLaime').remove();
            });
        }
    });
});
